import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { StatusDashboardContainerProps } from "../../../../interfaces/containers";
import Status from "../../../../pages/Profile/Dashboard/ChartByStatus";
import { getStatusPublications, cleanStatusPublications, getStatusTransactions, cleanStatusTransactions } from "../../../../actions/dashboard";

function mapStateToProps(state: StatusDashboardContainerProps) {
    return {
        user: state.auth.user,
        branch: state.profile.dashboard.branch,
        status: state.profile.dashboard.status,
        date: state.profile.dashboard.date
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getStatusPublications,
        cleanStatusPublications,
        getStatusTransactions,
        cleanStatusTransactions
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Status);